<template>
  <TopicPage :entry="entry" :categories="entry.categories" />
</template>
<script>
import topicPage, { TopicQuery } from '@/mixins/topicPage';
import { stripLocale } from '@/utils/i18n';
import TopicPage from '~/components/knowledge/topic/TopicPage';

export default defineNuxtComponent({
  name: 'MainTopicPage',

  components: {
    TopicPage,
  },
  mixins: [topicPage],

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const slug = route.params?.topic;
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri, slug };

    const { entry, seomatic, topics } = await $craftRequest(TopicQuery, variables);

    return { entry, seomatic, topics, categories: entry.categories };
  },

  mounted() {
    this.setTopicCategories();
    this.gtmPushPageMeta({ content_category: 'knowledge', content_subcategory: this.entry?.slug });
  },
});
</script>
